<template>
  <div>
    <Head :title="$t('languages.new')"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" href="/languages">{{ $t('languages.languages') }}</Link>
      <span class="text-gray-400 font-medium">/ </span> {{ $t('languages.new') }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <Form :form-data="form" :types="types"></Form>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ $t('global.create') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  props: {
    types: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        id: '',
        name: '',
        types: [],
        deleted_at: '',
        empty_field: false,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/languages')
    },
  },
}
</script>
